const Button = ({ children, disabled = false, className = '', ...props }) => {
  return (
    <button
      className={`md:text-[1.4rem] lg:text-4xl text-[1rem] uppercase text-black bg-brandAccent sm:px-[2.2rem] md:px-20 lg:px-[6rem] px-6 sm:py-[0.8rem] md:py-[1rem] lg:py-[2rem] py-[0.6rem] sm:rounded-2xl rounded-[0.4rem] mx-auto md:my-8 my-4 relative flex items-center justify-center z-20 ${className}
      `}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
